<nz-modal [(nzVisible)]="isVisible" [nzTitle]="titleTpl" [nzOkLoading]="okLoading" (nzOnCancel)="isVisible = false"
  (nzOnOk)="handleOk()" nzWidth="600px" nzOkText="Submit">
  <ng-template #titleTpl>
    <div class="title">
      UOB Online Payment - {{selectedMode.label}}
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <form nz-form se-container="1" nzLayout="horizontal" labelWidth="150">
      <se-title>MODE</se-title>
      <nz-divider class="m-sm"></nz-divider>
      <se label="Transaction Type" required [error]="'Transaction Type is required.'">
        <nz-select name="transactionType" [(ngModel)]="data.transactionType" (ngModelChange)="changeMode()"
          [nzOptions]="modeOptions">
        </nz-select>
      </se>
    </form>
    <nz-divider class="m-sm"></nz-divider>
    <div [ngSwitch]="data.transactionType">
      <div *ngSwitchCase="1">
        <app-local-uob [data]="data"></app-local-uob>
      </div>
      <div *ngSwitchCase="3">
        <app-uob-duitnow-proxy [data]="data"></app-uob-duitnow-proxy>
      </div>
      <div *ngSwitchCase="4">
        <app-uob-tt [data]="data"></app-uob-tt>
      </div>
      <div *ngSwitchCase="5">
        <app-uob-duitnow [data]="data"></app-uob-duitnow>
      </div>
    </div>
  </ng-container>
</nz-modal>
